export interface AlertServiceEvent {
    type: AlertServiceEventType;
    data: any;
}

export enum AlertServiceEventType {
    LoadingPage,
    Notify,
    DialogRequest,
    DialogResponse,
    ConfirmRequest,
    ConfirmResponse,
}